import React, { useState } from 'react';

interface HelpTooltipProps {
  content: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({ 
  content, 
  position = 'top',
  className = '' 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
      case 'bottom':
        return 'top-full left-1/2 transform -translate-x-1/2 mt-2';
      case 'left':
        return 'right-full top-1/2 transform -translate-y-1/2 mr-2';
      case 'right':
        return 'left-full top-1/2 transform -translate-y-1/2 ml-2';
      default:
        return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
    }
  };

  const getArrowClasses = () => {
    switch (position) {
      case 'top':
        return 'top-full left-1/2 transform -translate-x-1/2 border-t-medical-gray-800';
      case 'bottom':
        return 'bottom-full left-1/2 transform -translate-x-1/2 border-b-medical-gray-800';
      case 'left':
        return 'left-full top-1/2 transform -translate-y-1/2 border-l-medical-gray-800';
      case 'right':
        return 'right-full top-1/2 transform -translate-y-1/2 border-r-medical-gray-800';
      default:
        return 'top-full left-1/2 transform -translate-x-1/2 border-t-medical-gray-800';
    }
  };

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <button
        type="button"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsVisible(!isVisible);
        }}
        className="w-5 h-5 bg-medical-gray-300 hover:bg-medical-gray-400 text-medical-gray-700 rounded-full flex items-center justify-center text-xs font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-medical-blue-400"
        aria-label="Help"
      >
        ?
      </button>
      
      {isVisible && (
        <div
          className={`absolute z-50 ${getPositionClasses()} transition-opacity duration-200`}
          role="tooltip"
        >
          <div className="bg-medical-gray-800 text-white text-sm rounded-lg px-4 py-2 shadow-lg max-w-xs whitespace-normal">
            {content}
            <div
              className={`absolute w-0 h-0 border-4 border-transparent ${getArrowClasses()}`}
              style={{
                borderTopColor: position === 'bottom' ? 'transparent' : undefined,
                borderBottomColor: position === 'top' ? 'transparent' : undefined,
                borderLeftColor: position === 'right' ? 'transparent' : undefined,
                borderRightColor: position === 'left' ? 'transparent' : undefined,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

// Note: FloatingHelpButton has been replaced with contextual help system
// See ContextualHelpCard and useSmartHelp for the new implementation